<template>
    <div class="center-dropdown-holder">
        <div class="center-dropdown">
            <div class="center-dropdown-star pointer">
                <i
                    :class="
                        authStore.user.settings.main_center ==
                        authStore.user.current_center.center_id
                            ? 'grade-selected material-icons'
                            : 'material-icons-outlined icon-rock'
                    "
                    class="pointer"
                    @click="
                        selectMainCenter(
                            authStore.user.current_center.center_id
                        )
                    "
                    >grade</i
                >
            </div>
            <div
                class="center-dropdown-selected pointer"
                @click="centerDropDownShow = !centerDropDownShow"
            >
                <span>{{ authStore.user.current_center.name }}</span>
                <i
                    :class="centerDropDownShow ? 'dropdown-arrow-open' : ''"
                    class="material-icons icon-rock pointer dropdown-arrow"
                    >arrow_drop_down</i
                >
            </div>
        </div>

        <div
            class="center-dropdown-items scroll-bar-no-padding"
            v-if="centerDropDownShow"
        >
            <ul>
                <li
                    v-for="center in authStore.user.centers"
                    :class="
                        center.center_id ==
                        authStore.user.current_center.center_id
                            ? 'center-dropdown-item-selected'
                            : ''
                    "
                >
                    <div class="center-dropdown-star">
                        <i
                            :class="
                                authStore.user.settings.main_center ==
                                center.center_id
                                    ? 'grade-selected material-icons'
                                    : 'material-icons-outlined icon-rock'
                            "
                            class="pointer"
                            @click="selectMainCenter(center.center_id)"
                            >grade</i
                        >
                    </div>
                    <div
                        class="center-dropdown-change"
                        @click="changeCenter(center)"
                    >
                        {{ center.name }} - {{ center.center_id }}
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <Loading :loading="loading" />
</template>

<script>
import axios from "axios";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { mapStores } from "pinia";
import { useAuthStore } from "../../stores/auth.js";

export default {
    computed: {
        ...mapStores(useAuthStore),
    },
    emits: ["centerSelected"],
    data() {
        return {
            loading: false,
            centerDropDownShow: false,
        };
    },
    methods: {
        selectMainCenter(centerId) {
            if (centerId == this.authStore.user.settings.main_center) {
                this.removeMainCenter();
                return;
            }

            this.loading = true;
            let self = this;

            axios
                .post(
                    self.authStore.api + "/user/setMainCenter",
                    {
                        centerId: centerId,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                    }
                )
                .then((response) => {
                    this.loading = false;

                    // Update localstorage and store!
                    self.authStore.user.settings.main_center = centerId;
                    localStorage.setItem(
                        "user",
                        JSON.stringify(self.authStore.user)
                    );

                    toast("Favorit anläggning sparad", {
                        type: "success",
                        position: "bottom-right",
                        autoClose: 1000,
                        dangerouslyHTMLString: true,
                    });
                })
                .catch((error) => {
                    this.loading = false;
                });
        },
        changeCenter(center) {
            this.authStore.user.pre_center = JSON.parse(
                JSON.stringify(this.authStore.user.current_center)
            );
            this.authStore.user.current_center = center;
            localStorage.setItem("user", JSON.stringify(this.authStore.user));

            this.$emit("centerSelected");
            this.centerDropDownShow = false;
        },
        removeMainCenter() {
            this.loading = true;
            let self = this;

            axios
                .post(
                    self.authStore.api + "/user/deleteMainCenter",
                    {},
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                    }
                )
                .then((response) => {
                    this.loading = false;

                    // Update localstorage and store!
                    self.authStore.user.settings.main_center = false;
                    localStorage.setItem(
                        "user",
                        JSON.stringify(self.authStore.user)
                    );

                    toast("Favorit anläggning borttagen", {
                        type: "success",
                        position: "bottom-right",
                        autoClose: 1000,
                        dangerouslyHTMLString: true,
                    });
                })
                .catch((error) => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style>
.center-dropdown-holder {
    width: calc(100% + 28px);
    margin-left: -14px;
    position: relative;

    @media (min-width: 1070px) {
        width: 410px;
        max-width: 100%;
        margin-right: -5px;
    }
}

.center-dropdown {
    width: 100%;
    height: 44px;
    display: flex;
    border-top: 1px solid #d9d8d6;
    background-color: #fff;
    padding: 0;
    font-weight: 700;
    align-items: center;
    justify-content: space-between;
    font-family: "hansen-grotesque-bold", sans-serif;
    font-size: 13px;

    @media (min-width: 1070px) {
        height: 50px;
        border: 1px solid rgba(161, 177, 200, 0.5);
        border-radius: 6px;
        font-size: 16px;
        margin-left: 12px;
    }
}

.center-dropdown-star {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
}

.center-dropdown-selected {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    height: 100%;
    margin-left: 3px;

    i {
        margin-right: 10px;
    }
}

.dropdown-arrow {
    font-size: 38px;
    color: #0033ff;
    transition: all 0.2s ease;
}

.dropdown-arrow-open {
    transform: rotate(180deg);
    transition: all 0.2s ease;
}

.center-dropdown-items {
    position: absolute;
    width: 100%;
    max-height: 400px;
    overflow-y: auto;
    background-color: #fff;
    z-index: 100;
    box-shadow: 4px 4px 4px 0px #00000040;
    border: 1px solid rgba(161, 177, 200, 0.5);
    left: 12px;

    @media (min-width: 1070px) {
        border-radius: 6px;
    }

    li {
        display: flex;
        height: 50px;
        align-items: center;
        transition: all 0.2s ease;

        &:hover {
            background-color: rgba(247, 248, 249, 1);
            transition: all 0.2s ease;
        }
    }
}

.center-dropdown-change {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: 700;
    font-family: "hansen-grotesque-bold", sans-serif;
}

.center-dropdown-item-selected {
    background-color: #eff0f2;
}
</style>
